import { useRouter } from 'next/router'
import { FC, ReactNode, createContext, useContext, useEffect, useState } from 'react'

import { FeatureFlag } from 'shared/enums/FeatureFlag'
import { useFeatureFlag } from 'featureFlags/hooks/useFeatureFlag'

interface IAccountPageContext {
  activeOrderNumber: number | null
  setActiveOrderNumber: (orderNumber: number | null) => void
}

export const AccountPageContext = createContext<IAccountPageContext>({
  activeOrderNumber: null,
  setActiveOrderNumber: () => null,
})

export const useAccountPageContext = () => useContext(AccountPageContext)

interface IAccountPageContextProvider {
  children: ReactNode
  orderNumber: number | null
}
const AccountPageContextProvider: FC<IAccountPageContextProvider> = ({ children, orderNumber }) => {
  const isOffersEnabled = useFeatureFlag(FeatureFlag.TEMP_WEB_FC_ENABLE_OFFERS)
  const [activeOrderNumber, setActiveOrderNumber] = useState(orderNumber)
  const { locale, replace, query } = useRouter()
  const state = {
    activeOrderNumber,
    setActiveOrderNumber,
  }

  const getAllowedQueryParams = () => {
    if (activeOrderNumber) {
      return `?active-order=${activeOrderNumber}`
    }

    if (query?.view) {
      const allowedViewQueryParamValues = ['favorites']
      if (isOffersEnabled) {
        allowedViewQueryParamValues.push('offers')
      }
      const hasAllowedQueryParams = allowedViewQueryParamValues.includes(query?.view as string)

      if (hasAllowedQueryParams) {
        return `?${new URLSearchParams(query as Record<string, string>)}`
      }
    }

    return ''
  }

  useEffect(() => {
    const queryParams = getAllowedQueryParams()
    replace(`/my-account${queryParams}`, `/my-account${queryParams}`, {
      shallow: true,
      locale,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOrderNumber, locale, query?.view])
  return <AccountPageContext.Provider value={state}>{children}</AccountPageContext.Provider>
}
export default AccountPageContextProvider
